import React, { useState } from 'react';
import { Frame, Toast } from '@shopify/polaris';

export default function Layout({ children }) {
  const [toastActive, setToastActive] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const dismissToast = () => setToastActive(false);

  const toastMarkup = toastActive ? (
    <Toast
      content={toastMessage}
      onDismiss={dismissToast}
      duration={3000}
    />
  ) : null;

  return (
    <div style={{ height: '100vh' }}>
      <Frame>
        <div className="inclub-main-content">
          {children}
        </div>

        {toastMarkup}
      </Frame>
    </div>
  );
}